import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=44d9130e&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44d9130e')) {
      api.createRecord('44d9130e', component.options)
    } else {
      api.reload('44d9130e', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=44d9130e&", function () {
      api.rerender('44d9130e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/Profile.vue"
export default component.exports